import { Typography } from 'lighthouse';

import Reveal from '../Reveal';

import { CardPos, Location, ShieldTick, Timer1 } from 'iconsax-react';

const benefits = [
    {
        id: 1,
        icon: <Location size={26} color='#008fff' />,
        title: 'سرویس در محل',
        description: 'خونه، محل کار یا وسط خیابون؛ بدون نیاز به یدک‌کشی، کارشناس میاد پیشت.'
    },
    {
        id: 2,
        icon: <Timer1 size={26} color='#008fff' />,
        title: 'اعزام سریع کارشناس',
        description: 'معطل نمی‌مونی؛ کارشناس در کوتاه‌ترین زمان ممکن کنار ماشینته.'
    },
    {
        id: 3,
        icon: <ShieldTick size={26} color='#008fff' />,
        title: 'باتری اصل با گارانتی معتبر',
        description: 'خرید مستقیم باتری اورجینال با گارانتی رسمی؛ خیالت از اصالت کالا راحته.'
    },
    {
        id: 4,
        icon: <CardPos size={26} color='#008fff' />,
        title: 'قیمت شفاف، پرداخت امن',
        description: 'تسویه آنلاین و شفاف؛ بدون هزینه پنهان و بدون هزینه امداد.'
    }
];

const WhyAzki = () => {
    return (
        <section className='w-full bg-[#F6F9FF] py-16'>
            <div className='mx-auto w-full max-w-6xl px-5'>
                <Reveal>
                    <Typography variant='h5' component='h2' fontWeight={800} color='blackHighEmphasis' align='center'>
                        چرا باتری به باتری ازکی‌سرویس؟
                    </Typography>
                </Reveal>

                <div className='mt-8 grid grid-cols-2 gap-3 lg:grid-cols-4 lg:gap-4'>
                    {benefits.map((benefit, index) => (
                        <Reveal key={benefit.id} delay={index * 100}>
                            <div
                                className='flex h-full flex-col items-center rounded-lg bg-white p-5 text-center shadow-elevation1 ring-1 ring-black/5
                                    transition-shadow duration-300 hover:shadow-elevation2 sm:p-6'>
                                <span className='flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10'>{benefit.icon}</span>
                                <Typography variant='subtitle2' component='h3' fontWeight={700} color='blackHighEmphasis' className='mt-3'>
                                    {benefit.title}
                                </Typography>
                                <Typography variant='caption' component='p' color='blackMediumEmphasis' className='mt-1.5 leading-6'>
                                    {benefit.description}
                                </Typography>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default WhyAzki;
